import styled from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, transition } from 'theme/theme';

export const MobileSearchMenuContainer = styled.div<{ $open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  transform: ${(props) =>
    props.$open ? 'translateY(0)' : 'translateY(-100vh)'};
  width: 100%;
  height: 100vh;
  transition: all ${transition};
  overflow: hidden;
  background-color: ${colors.white};
  z-index: 104;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }

  @media print {
    display: none;
  }
`;

export const MobileSearchMenuWrapper = styled.div`
  padding: 36px ${gutterWidth / 2}px;
`;

export const MobileSearchMenuHeader = styled.div`
  align-items: center;
  background: ${colors.white};
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 0 ${gutterWidth / 2}px;
  height: 60px;
  width: 100%;
  border-bottom: 1px solid ${colors.selectionGrey};
`;
